AFRAME.registerPrimitive('ui-input', {
    defaultComponents: {
        'ui-input': {}
    },
    mappings: {
        placeholder: 'ui-input.placeholder',
        value: 'ui-input.value',
        width: 'ui-input.width',
        height: 'ui-input.height',
        color: 'ui-input.color',
        focuscolor: 'ui-input.focuscolor'
    }
});

AFRAME.registerComponent('ui-input', {
    schema: {
        placeholder: { type: 'string', default: 'Enter text' },
        value: { type: 'string', default: '' },
        width: { type: 'number', default: 0.5 },
        height: { type: 'number', default: 0.2 },
        color: { type: 'string', default: '#555' },
        focuscolor: { type: 'string', default: '#E0E0E0' }
    },

    init: function () {
        this.createInput();
        this.bindInputEvents();
        this.isFocused = false;
        this.keyboardOverlay = null;
        this.isOverlayVisible = false;
        this.isQuestOverlayActive = false; // Track Quest native overlay
    },

    update: function (oldData) {
        if (!this.el.getObject3D('mesh')) return;

        if (oldData.width !== this.data.width || oldData.height !== this.data.height) {
            this.el.setAttribute('geometry', { primitive: 'plane', width: this.data.width, height: this.data.height });
        }
        if (oldData.color !== this.data.color && !this.isFocused) {
            this.el.setAttribute('material', 'color', this.data.color);
        }
        if (oldData.value !== this.data.value || oldData.placeholder !== this.data.placeholder) {
            const displayText = this.data.value || this.data.placeholder;
            this.text.setAttribute('value', displayText);
            this.text.setAttribute('color', this.data.value ? '#000' : '#888');
        }
    },

    createInput: function () {
        this.el.setAttribute('geometry', { primitive: 'plane', width: this.data.width, height: this.data.height });
        this.el.setAttribute('material', { color: this.data.color, shader: 'flat', transparent: true, opacity: 1 });

        this.text = document.createElement('a-text');
        const initialText = this.data.value || this.data.placeholder;
        this.text.setAttribute('value', initialText);
        this.text.setAttribute('align', 'center');
        this.text.setAttribute('position', '0 0 0.01');
        this.text.setAttribute('scale', '0.5 0.5 0.5');
        this.text.setAttribute('color', this.data.value ? '#000' : '#888');
        this.el.appendChild(this.text);
    },

    bindInputEvents: function () {
        this.el.addEventListener('click', () => {
            if (!this.isFocused) {
                this.focusInput();
            }
        });

        // Hardware keyboard input (Apple Magic Keyboard)
        document.addEventListener('keydown', (event) => {
            if (!this.isFocused) return;

            let currentValue = this.data.value || '';
            if (event.key === 'Enter') {
                this.blurInput();
            } else if (event.key === 'Backspace') {
                currentValue = currentValue.slice(0, -1);
            } else if (event.key.length === 1) {
                currentValue += event.key;
            }
            this.updateValue(currentValue);

            // Highlight key on custom overlay if Quest overlay isn't active
            if (!this.isQuestOverlayActive && this.isOverlayVisible) {
                this.highlightKey(event.key);
            }
        });
    },

    focusInput: function () {
        this.isFocused = true;
        this.el.setAttribute('material', 'color', this.data.focuscolor);

        // Assume Apple Magic Keyboard is paired; Quest should auto-overlay
        this.checkQuestOverlay();
        if (!this.isQuestOverlayActive) {
            this.showKeyboardOverlay(); // Fallback to custom overlay
        }
    },

    blurInput: function () {
        this.isFocused = false;
        this.el.setAttribute('material', 'color', this.data.color);
        if (this.keyboardOverlay) {
            this.keyboardOverlay.setAttribute('visible', false);
            this.isOverlayVisible = false;
        }
        this.el.emit('change', { value: this.data.value });
    },

    updateValue: function (newValue) {
        this.el.setAttribute('ui-input', 'value', newValue);
        this.text.setAttribute('value', newValue || this.data.placeholder);
    },

    checkQuestOverlay: function () {
        // WebXR doesn’t directly expose Quest’s tracked keyboard state, so we infer it
        // If keyboard is paired and hand tracking is on, assume Quest overlay is active
        // This is a simplification; real detection would need Quest SDK integration
        this.isQuestOverlayActive = true; // For now, assume it works if paired
    },

    showKeyboardOverlay: function () {
        if (!this.keyboardOverlay) {
            this.keyboardOverlay = this.createKeyboardOverlay();
            this.el.sceneEl.appendChild(this.keyboardOverlay);
        }

        // Default position in front of user; adjust as needed
        this.keyboardOverlay.setAttribute('position', '0 0.5 -1');
        this.keyboardOverlay.setAttribute('visible', true);
        this.isOverlayVisible = true;
        this.setupOverlayInteraction();
    },

    createKeyboardOverlay: function () {
        // Simplified Apple Magic Keyboard layout
        const keyboard = document.createElement('a-entity');
        keyboard.setAttribute('geometry', 'primitive: plane; width: 1.2; height: 0.4'); // Magic Keyboard size
        keyboard.setAttribute('material', 'color: #F5F5F5; opacity: 0.8'); // Light gray like Magic Keyboard

        const keys = 'qwertyuiopasdfghjklzxcvbnm'.split('').concat([' ', 'delete', 'return']);
        let xOffset = -0.55;
        let yOffset = 0.15;
        this.keyEntities = {};

        keys.forEach((key, index) => {
            const keyEntity = document.createElement('a-entity');
            keyEntity.setAttribute('geometry', 'primitive: plane; width: 0.08; height: 0.08');
            keyEntity.setAttribute('material', 'color: #FFF');
            keyEntity.setAttribute('position', `${xOffset} ${yOffset} 0.01`);
            this.keyEntities[key] = keyEntity;

            const keyText = document.createElement('a-text');
            keyText.setAttribute('value', key === ' ' ? 'Space' : key === 'delete' ? 'Del' : key === 'return' ? 'Ret' : key);
            keyText.setAttribute('align', 'center');
            keyText.setAttribute('scale', '0.3 0.3 0.3');
            keyText.setAttribute('color', '#000');
            keyEntity.appendChild(keyText);

            keyboard.appendChild(keyEntity);
            xOffset += 0.1;
            if ((index + 1) % 10 === 0) {
                xOffset = -0.55;
                yOffset -= 0.1;
            }
        });

        return keyboard;
    },

    highlightKey: function (key) {
        const normalizedKey = key.toLowerCase() === 'backspace' ? 'delete' : key.toLowerCase() === 'enter' ? 'return' : key.toLowerCase();
        if (!this.isOverlayVisible || !this.keyEntities[normalizedKey]) return;

        const keyEntity = this.keyEntities[normalizedKey];
        keyEntity.setAttribute('material', 'color', '#00FF00');
        setTimeout(() => {
            keyEntity.setAttribute('material', 'color', '#FFF');
        }, 100);
    },

    setupOverlayInteraction: function () {
        this.keyboardOverlay.setAttribute('class', 'interactable');
        this.keyboardOverlay.addEventListener('grab-start', (event) => {
            this.isDragging = true;
            this.grabbedController = event.detail.hand;
        });

        this.keyboardOverlay.addEventListener('grab-end', () => {
            this.isDragging = false;
            this.grabbedController = null;
        });

        this.el.sceneEl.addEventListener('tick', () => {
            if (this.isDragging && this.grabbedController) {
                const controllerPos = this.grabbedController.getAttribute('position');
                this.keyboardOverlay.setAttribute('position', `${controllerPos.x} ${controllerPos.y} ${controllerPos.z - 0.1}`);
            }
        });
    },

    getValue: function () {
        return this.data.value;
    }
});